module.exports = __webpack_public_path__ + "static/img/li1_7.2f90876e.png";